var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgMenuAccount = function SvgMenuAccount(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 26,
    viewBox: "0 0 25 26",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 0.911774C5.625 0.911774 0 6.53677 0 13.4118C0 20.2868 5.625 25.9118 12.5 25.9118C19.375 25.9118 25 20.2868 25 13.4118C25 6.53677 19.375 0.911774 12.5 0.911774ZM12.5 4.66177C14.625 4.66177 16.25 6.28677 16.25 8.41177C16.25 10.5368 14.625 12.1618 12.5 12.1618C10.375 12.1618 8.75 10.5368 8.75 8.41177C8.75 6.28677 10.375 4.66177 12.5 4.66177ZM12.5 22.4118C9.375 22.4118 6.625 20.7868 5 18.4118C5 15.9118 10 14.5368 12.5 14.5368C15 14.5368 20 15.9118 20 18.4118C18.375 20.7868 15.625 22.4118 12.5 22.4118Z"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgMenuAccount, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/menu_account.b6905045.svg";
export { ForwardRef as ReactComponent };